import {connect} from 'react-redux'
import {DefaultTemplate} from './page'
import {hasUnreadNotifications} from "../../../pages"

const mapStateToProps = (state) => ({
  hasUnreadNotifications: hasUnreadNotifications(state)
})

// const mapDispatchToProps = (dispatch) => ({
//   getNotifications: () => dispatch(getNotifications())
// })

export const DefaultTemplateConnected = connect(mapStateToProps, null)(DefaultTemplate)